import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import { useDispatch, useSelector } from "react-redux";
import { getConfig, searchAPI } from "../../../apis";
import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import { setSummaryInfoData } from "../../../redux/features/dataSlice";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../functions/isMobile";
import { getFormattedDate, getRegularDate } from "../../../functions/time";
import { Tooltip } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DateComponent from "../../../components/DateComponent";
import { axiosInstance } from "../../../functions/axios";

const UpdateSummary = (props) => {
  const isMobile = useIsMobile();

  const {
    showPopup,
    setShowPopup,
    summary,
    setSummary,
    bookmark,
    getBookmarks,
  } = props;
  const [edit, setEdit] = useState(false);
  const [position, setPosition] = useState({
    marginTop: -44,
    marginLeft: -41,
  });
  const [changeTooltip, setChangeTooltip] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { summaryInfoData } = useSelector((state) => state.data);
  const [calendarPopup, setCalendarPopup] = useState(false);

  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleCopy = () => {
    const getSummaryData = summaryInfoData;
    const copiedData = `Publisher: ${getSummaryData.publisher} \nTitle: ${
      getSummaryData.title
    } \nPublished date: ${getFormattedDate(
      getSummaryData.published_date
    )} \nLink: ${getSummaryData.url} \n\nSummary: ${summary}`;
    navigator.clipboard.writeText(copiedData).catch((error) => {
      console.error("Unable to copy data to clipboard:", error);
    });
    setChangeTooltip(true);
  };

  const updateSummary = async () => {
    let publish_date;
    try {
      publish_date = new Date(summaryInfoData.published_date);
    } catch {
      toast.error("Please enter a valid date in dd/mm/yyyy format");
      return;
    }
    const json_res = {
      callingUserId: user.userId,
      collectionSourceId: bookmark.collectionSourceID_ids,
      collectionId: bookmark.collectionID_lng,
      userId: user.userId,
      title: summaryInfoData.title,
      title: summaryInfoData.title,
      sourceURL: summaryInfoData.url,
      sourcePublishedDateTime: publish_date,
      sourceName: summaryInfoData.publisher,
      summary: summary,
    };
    try {
      const res = await axiosInstance.post(
        searchAPI.AddUpdateCollectionsSource,
        json_res,
        getConfig()
      );
      toast.success("Summary updated successfully.");
      const searchParams = new URLSearchParams(location.search);
      const search = searchParams.get("search");
      !search && getBookmarks(params.id);
      // setShowPopup(false);
      setEdit(false);
    } catch {
      toast.error("Something went wrong. Please try again.");
    }
  };

  const tooltipTitle = changeTooltip
    ? "Copied to clipboard"
    : "Copy to clipboard";

  const handleEdit = async () => {
    setEdit((prev) => !prev);
  };

  const handleMouseOut = (event) => {
    setTimeout(() => {
      const fromElement = event.relatedTarget;
      const tooltipButton = document.getElementById("tooltipButton");

      if (!tooltipButton.contains(fromElement)) {
        setChangeTooltip(false);
      }
    }, 1000);
  };

  const handleSave = () => {
    updateSummary();
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  const setDate = (date) => {
    let new_date = new Date(date);
    if (isNaN(new_date.getTime())) {
      new_date = null;
    }
    const updatedValue = {
      ...summaryInfoData,
      published_date: getRegularDate(new_date),
    };
    dispatch(setSummaryInfoData(updatedValue));
  };

  const reqDate = () => {
    let new_date = new Date(summaryInfoData.published_date);
    if (isNaN(new_date.getTime())) {
      new_date = null;
    }
    console.log("date", new_date);
    return new_date;
  };

  const updateSummaryText = () => {
    let currentText = summary;
    currentText = currentText.replace(/\n{3,}/g, "\n\n");
    setSummary(currentText);
  };

  const handleChange = (e) => {
    setSummary(e.target.value);
  };

  return (
    showPopup && (
      <>
        <div className="bg-dark" />
        {!isMobile ? (
          <Draggable
            defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
            onDrag={handleDrag}
            cancel={isMobile ? ".new-summary-popup" : null}
          >
            <div className="new-summary-popup">
              <div className="popup-card">
                <CloseIcon
                  className="cross"
                  onClick={() => setShowPopup(false)}
                />

                <p className="popup-title">Article Summary</p>
                <div className="title-container">
                  <div className="mt-1 summary-boxes">
                    <div className="space-between">
                      <span className="first-col">Source:</span>{" "}
                      <input
                        type="text"
                        value={summaryInfoData.publisher}
                        disabled={!edit}
                        className="summary-box"
                        onChange={(e) => {
                          const updatedValue = {
                            ...summaryInfoData,
                            publisher: e.target.value,
                          };
                          dispatch(setSummaryInfoData(updatedValue));
                        }}
                      />
                    </div>
                    <div></div>
                  </div>
                  <div className="mt-1 summary-boxes">
                    <div className="space-between">
                      <span className="first-col">Published Date:</span>{" "}
                      <div className="space-between-date">
                        <input
                          type="text"
                          value={summaryInfoData.published_date}
                          disabled={!edit}
                          className="summary-box"
                          onChange={(e) => {
                            const updatedValue = {
                              ...summaryInfoData,
                              published_date: e.target.value,
                            };
                            dispatch(setSummaryInfoData(updatedValue));
                          }}
                        />
                        <Tooltip title="View calendar">
                          <CalendarMonthIcon
                            style={{ cursor: "pointer" }}
                            className=""
                            onClick={() => setCalendarPopup(true)}
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <div></div>
                  </div>{" "}
                  <div className="mt-1 summary-boxes">
                    <div className="space-between">
                      <span className="first-col">Title:</span>{" "}
                      <input
                        type="text"
                        value={summaryInfoData.title}
                        disabled={!edit}
                        className="summary-box"
                        onChange={(e) => {
                          const updatedValue = {
                            ...summaryInfoData,
                            title: e.target.value,
                          };
                          dispatch(setSummaryInfoData(updatedValue));
                        }}
                      />
                    </div>
                    <div></div>
                  </div>
                  <div className="mt-1 summary-boxes">
                    <div className="space-between">
                      <span className="first-col">URL:</span>{" "}
                      <input
                        type="text"
                        value={summaryInfoData.url}
                        disabled={!edit}
                        className="summary-box"
                        onChange={(e) => {
                          const updatedValue = {
                            ...summaryInfoData,
                            url: e.target.value,
                          };
                          dispatch(setSummaryInfoData(updatedValue));
                        }}
                      />
                    </div>
                    <div className="mt-1"></div>
                  </div>
                </div>
                {edit ? (
                  <div className="summary">
                    <textarea
                      className="edit-textarea"
                      value={summary}
                      onBlur={updateSummaryText}
                      onChange={handleChange}
                    />
                  </div>
                ) : (
                  <div className="summary">
                    <p className="summary-desc">
                      {summary.split("\n\n").map((bullet, index) => (
                        <li className="mb-2" key={index}>
                          {bullet}
                        </li>
                      ))}
                    </p>
                  </div>
                )}

                <div className="save-actions">
                  <div />
                  <div className="flex">
                    <Tooltip title={tooltipTitle}>
                      <button
                        id="tooltipButton"
                        className="btn-copy outlined mr-2"
                        onClick={handleCopy}
                        onMouseOut={handleMouseOut}
                      >
                        <p>Copy</p>
                      </button>
                    </Tooltip>
                    {edit && (
                      <ButtonPrimary
                        text="Cancel"
                        onClick={() => {
                          setEdit(false);
                        }}
                        className="mr-2 grey"
                        outline
                      />
                    )}
                    {!edit ? (
                      <ButtonPrimary text="Edit" onClick={handleEdit} />
                    ) : (
                      <ButtonPrimary text="Save" onClick={handleSave} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Draggable>
        ) : (
          <div className="new-summary-popup">
            <div className="popup-card">
              <CloseIcon
                className="cross"
                onClick={() => setShowPopup(false)}
              />

              <p className="popup-title">Article Summary</p>
              <div className="title-container">
                <div className="mt-1 summary-boxes">
                  <div className="space-between">
                    <span className="first-col">Source:</span>{" "}
                    <input
                      type="text"
                      value={summaryInfoData.publisher}
                      disabled={!edit}
                      className="summary-box"
                      onChange={(e) => {
                        const updatedValue = {
                          ...summaryInfoData,
                          publisher: e.target.value,
                        };
                        dispatch(setSummaryInfoData(updatedValue));
                      }}
                    />
                  </div>
                  <div></div>
                </div>
                <div className="mt-1 summary-boxes">
                  <div className="space-between">
                    <span className="first-col">Published Date:</span>{" "}
                    <div className="space-between-date">
                      <input
                        type="text"
                        value={summaryInfoData.published_date}
                        disabled={!edit}
                        className="summary-box"
                        onChange={(e) => {
                          const updatedValue = {
                            ...summaryInfoData,
                            published_date: e.target.value,
                          };
                          dispatch(setSummaryInfoData(updatedValue));
                        }}
                      />
                      <Tooltip title="View calendar">
                        <CalendarMonthIcon
                          style={{ cursor: "pointer" }}
                          className=""
                          onClick={() => setCalendarPopup(true)}
                        />
                      </Tooltip>
                    </div>
                  </div>
                  <div></div>
                </div>{" "}
                <div className="mt-1 summary-boxes">
                  <div className="space-between">
                    <span className="first-col">Title:</span>{" "}
                    <input
                      type="text"
                      value={summaryInfoData.title}
                      disabled={!edit}
                      className="summary-box"
                      onChange={(e) => {
                        const updatedValue = {
                          ...summaryInfoData,
                          title: e.target.value,
                        };
                        dispatch(setSummaryInfoData(updatedValue));
                      }}
                    />
                  </div>
                  <div></div>
                </div>
                <div className="mt-1 summary-boxes">
                  <div className="space-between">
                    <span className="first-col">URL:</span>{" "}
                    <input
                      type="text"
                      value={summaryInfoData.url}
                      disabled={!edit}
                      className="summary-box"
                      onChange={(e) => {
                        const updatedValue = {
                          ...summaryInfoData,
                          url: e.target.value,
                        };
                        dispatch(setSummaryInfoData(updatedValue));
                      }}
                    />
                  </div>
                  <div className="mt-1"></div>
                </div>
              </div>
              {edit ? (
                <div className="summary">
                  <textarea
                    className="edit-textarea"
                    value={summary}
                    onBlur={updateSummaryText}
                    onChange={handleChange}
                  />
                </div>
              ) : (
                <div className="summary">
                  <p className="summary-desc">
                    {" "}
                    {summary.split("\n\n").map((bullet, index) => (
                      <li className="mb-2" key={index}>
                        {bullet}
                      </li>
                    ))}
                  </p>
                </div>
              )}

              <div className="save-actions">
                <div />
                <div className="flex">
                  <Tooltip title={tooltipTitle}>
                    <button
                      id="tooltipButton"
                      className="btn-copy outlined mr-2"
                      onClick={handleCopy}
                      onMouseOut={handleMouseOut}
                    >
                      <p>Copy</p>
                    </button>
                  </Tooltip>
                  {edit && (
                    <ButtonPrimary
                      text="Cancel"
                      onClick={() => {
                        setEdit(false);
                      }}
                      className="mr-2 grey"
                      outline
                    />
                  )}
                  {!edit ? (
                    <ButtonPrimary text="Edit" onClick={handleEdit} />
                  ) : (
                    <ButtonPrimary text="Save" onClick={handleSave} />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {calendarPopup && (
          <DateComponent
            setCalendarPopup={setCalendarPopup}
            reqDate={reqDate}
            setDate={setDate}
            requiredDates={0}
          />
        )}
      </>
    )
  );
};

export default UpdateSummary;
